import { PAGE_TYPE_DATA } from 'www/modules/Schedule/constants'
import { getModuleDataInterface, getModuleOptionsInterface } from 'www/modules/Schedule/models'
import {
  getPageConvertedData,

  getRenderLpuData,
  getRenderDoctorsData,
  getRenderServicesData,
  getRenderDoctorsLpuData,
} from 'www/modules/Schedule/classes/ScheduleData/functions'

/**
 * @description
 * Модуль производит работу с данными.
 * Он собирает, обновляет и удаляет данные.
 * Его задача - хранилище данных.
 *
 * @param {object} opts -
 * @param {object} opts.options - настройки модуля 'Schedule' - интерфейс 'getModuleOptionsInterface'
 */
class ScheduleData {
  data = getModuleDataInterface()

  #options = getModuleOptionsInterface()

  constructor({ options }) {
    this.#options = options
    this.create()
  }

  /**
   * @public
   * @description
   * Собирает данные со страницы, форматирует и типизирует их
   */
  create() {
    try {
      this.data = getPageConvertedData({ options: this.#options })
    } catch { /* Empty */ }
  }

  /**
   * @public
   * @description
   * Сбрасывает данные, используя базовый интерфейс за основу.
   */
  reset() { this.data = getModuleDataInterface() }

  /**
   * @public
   * @description
   * Производит обновление данных для рендера расписания.
   *
   * @param {object} response -
   * @param { Array } response.result - результат ответа
   * @param { Array } response.data - данные ответа по телемеду
   * @param { HTMLElement | undefined } parentCard - родительский узел, в котором произошло событие.
   * @param {boolean} serviceData - требует ли процедура первичный приём. Используется только на услугах
   * @param {boolean} isTelemed - по телемеду ли запись
   * Если необходимо собрать данные для рендера для всей страницы - parentCard === undefined
   * Если необходимо отрендерить календарь только в 1 карточке - должен быть передан parentCard === HTMLElement
   */
  updateRenderData(response, parentCard, serviceData, isTelemed) {
    try {
      const responseData = isTelemed ? response.data : response.result

      switch (this.#options.pageType) {
        case PAGE_TYPE_DATA.lpu:
          this.data.render = getRenderLpuData({
            response: responseData,
            parentCard,
            data: this.data,
            dataItem: this.#options.dataItem,
          })

          break
        case PAGE_TYPE_DATA.doctors:
          this.data.render = getRenderDoctorsData({
            response: responseData,
            parentCard,
            data: this.data,
            dataItem: this.#options.dataItem,
            isTelemed,
          })

          break
        case PAGE_TYPE_DATA.doctorsLpu:
          this.data.render = getRenderDoctorsLpuData({
            response: responseData,
            parentCard,
            data: this.data,
            dataItem: this.#options.dataItem,
            isTelemed,
          })

          break
        case PAGE_TYPE_DATA.services:
          this.data.render = getRenderServicesData({
            response: responseData,
            serviceData,
            parentCard,
            data: this.data,
            dataItem: this.#options.dataItem,
          })

          break
      }
    } catch { /* Empty */ }
  }

  /**
   * @public
   * @description
   * Производит полное обновление данных для запроса.
   *
   * @param {object} opts -
   * @param {object} opts.requestData - один из интерфейсов 'getLpuRequestInterface' | 'getDoctorRequestInterface' | 'getDoctorOnlineRequestInterface' | 'getServicesRequestInterface'
   */
  updateRequestData({ requestData }) {
    try {
      this.data.request = requestData
    } catch { /* Empty */ }
  }

  /**
   * @public
   * @description
   * Производит обновление Map списка со всеми отрендеренными инстансами расписания.
   * Причем не полностью заменяя, а подменяя часть содержимого Map списка на список инстансов, который передан.
   *
   * @param {object} opts -
   * @param { Map } opts.instances - список инстансов календарей, который необходимо добавить.
   * Форма списка - {HTMLElement: VueComponent}(его возвращает 'ScheduleCalendar.render()')
   */
  updateInstanceData({ instances }) {
    try {
      instances.forEach((instance, node) => { this.data.instances.set(node, instance) })
    } catch { /* Empty */ }
  }
}

export default ScheduleData
